import { render } from "./ModalRegistroOcorrencia.vue?vue&type=template&id=1d01eef0&scoped=true"
import script from "./ModalRegistroOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalRegistroOcorrencia.vue?vue&type=script&lang=js"

import "./ModalRegistroOcorrencia.vue?vue&type=style&index=0&id=1d01eef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d01eef0"]])

export default __exports__